<template>
	<div
		:class="[
			'flex',
			ctaCardVariants({ imageDesktopPosition, imageMobilePosition })
		]"
	>
		<div class="flex flex-1 flex-col gap-3 bg-secondary p-5 md:p-9">
			<h3
				class="font-matter-sq text-xl font-normal leading-normal tracking-[-0.5px] text-primary md:text-2xl"
			>
				<slot name="title" />
			</h3>
			<p
				class="text-sm font-normal leading-[1.75] text-primary-light-3 md:text-[16px]"
			>
				<slot name="description" />
			</p>
			<slot name="extra-content" />
		</div>
		<div v-if="imageSrc" :class="cn(imageClass, 'relative flex-1')">
			<slot name="image">
				<NuxtImg
					:src="imageSrc"
					width="720"
					height="400"
					sizes="xs:375px sm:500px lg:600px xl:720px"
					densities="x1"
					format="webp"
					class="pointer-events-none absolute inset-0 size-full object-cover object-[30%_50%] lg:object-[50%_55%]"
					draggable="false"
				/>
			</slot>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { CtaCardProps } from '.';

import { cn } from '~/utils';

import { ctaCardVariants } from '.';

withDefaults(defineProps<CtaCardProps>(), {
	imageDesktopPosition: 'right',
	imageSizes: '500px xl:720px',
	provider: 'AWSServerlessImageHandler'
});
</script>
